import { listingService } from 'src/services/listing';
import { SagaIterator } from 'redux-saga';
import { takeLatest, call, put, spawn, FixedTask } from 'typed-redux-saga';
import { FeaturedListingsActions } from './actions';
import { ListingBanner, ListingOrderBy, ListingRelation, ListingStatus } from 'src/enums/listing';
import { callWithRetry } from 'src/utils/call-with-retry';
import { configuration } from 'src/configurations/configuration';

export let loadFeaturedListingsTask: FixedTask<typeof loadFeaturedListings>;

function* loadFeaturedListings(): SagaIterator {
  const { maxAttempts, delayMs } = configuration.isrDataFetchRetry;

  try {
    const response = yield* callWithRetry(
      listingService.search,
      [
        {
          page: 1,
          perPage: 3,
          filters: { isFeatured: true, banner: ListingBanner.HIDDEN, status: ListingStatus.ACTIVE },
          relations: [ListingRelation.STATE, ListingRelation.COUNTY],
          orderBy: ListingOrderBy.ID,
          desc: true
        }
      ],
      maxAttempts,
      delayMs
    );

    yield* put(FeaturedListingsActions.loadFeaturedListingsSuccess({ response }));
  } catch (error) {
    yield* put(FeaturedListingsActions.loadFeaturedListingsFailure({ error }));

    throw error;
  }
}

function* loadFeaturedListingsForServer(): SagaIterator {
  yield* call(function* () {
    loadFeaturedListingsTask = yield* spawn(loadFeaturedListings);
  });
}

export default function* featuredListingsSaga(): SagaIterator {
  yield* takeLatest(FeaturedListingsActions.loadFeaturedListings, loadFeaturedListings);
  yield* takeLatest(FeaturedListingsActions.loadFeaturedListingsForServer, loadFeaturedListingsForServer);
}
